import { useState } from 'react';
import { IconSelected, IconUp, IconDown, ClickOutsideDetector } from '@ui/src';

import cn from './reports.module.css';

const list = [
  {
    name: '1 (.0)',
    value: '1',
  },
  {
    name: '2 (.00) Default',
    value: '2',
  },
  {
    name: '3 (.000)',
    value: '3',
  },
  {
    name: '4 (.0000)',
    value: '4',
  },
  {
    name: '5 (.00000)',
    value: '5',
  },
  {
    name: '6 (.000000)',
    value: '6',
  },
  {
    name: '7 (.0000000)',
    value: '7',
  },
  {
    name: '8 (.00000000)',
    value: '8',
  },
  {
    name: '9 (.000000000)',
    value: '9',
  },
  {
    name: '10 (.0000000000)',
    value: '10',
  },
  {
    name: '11 (.00000000000)',
    value: '11',
  },
  {
    name: '12 (.000000000000)',
    value: '12',
  },
  {
    name: '13 (.0000000000000)',
    value: '13',
  },
  {
    name: '14 (.00000000000000)',
    value: '14',
  },
  {
    name: '15 (.000000000000000)',
    value: '15',
  },
  {
    name: '16 (.0000000000000000)',
    value: '16',
  },
  {
    name: '17 (.00000000000000000)',
    value: '17',
  },
  {
    name: '18 (.000000000000000000)',
    value: '18',
  },
  {
    name: '19 (.0000000000000000000)',
    value: '19',
  },
  {
    name: '20 (.00000000000000000000)',
    value: '20',
  },
];

const PrecisionSelector = ({
  precision,
  setPrecision,
}: {
  precision: string;
  setPrecision: (data: string) => void;
}) => {
  const [menuVisible, setMenuVisible] = useState(false);

  return (
    <div className={cn.precisionWapper}>
      <ClickOutsideDetector setOptionsListVisible={setMenuVisible}>
        <>
          <button
            type="button"
            className={`${cn.precisionButton} ${menuVisible ? cn.active : ''}`}
            onClick={() => setMenuVisible(!menuVisible)}
          >
            <div className={cn.precisionButtonValue}>
              {`Precision: ${precision}`}
            </div>
            <div className={cn.precisionButtonIcon}>
              {menuVisible ? (
                <IconUp width={16} height={16} />
              ) : (
                <IconDown width={16} height={16} />
              )}
            </div>
          </button>
          {menuVisible && (
            <div className={cn.precisionList}>
              {list?.map((item) => (
                <button
                  type="button"
                  className={`${cn.precisionListButton} ${
                    item.value === precision ? cn.selected : ''
                  }`}
                  key={item.value}
                  onClick={() => {
                    setPrecision(item.value);
                    setMenuVisible(false);
                  }}
                >
                  <div className={cn.precisionListButtonValue}>{item.name}</div>
                  <div className={cn.precisionListButtonIcon}>
                    {item.value === precision && (
                      <IconSelected width={17} height={17} />
                    )}
                  </div>
                </button>
              ))}
            </div>
          )}
        </>
      </ClickOutsideDetector>
    </div>
  );
};

export default PrecisionSelector;
